import React from 'react'
import { useFormContext, useFieldArray } from 'react-hook-form'
import { useTranslate, required, SelectInput as SelectInputReactAdmin, FormDataConsumer } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Delete, Add } from '@mui/icons-material'
import Button from '@mui/material/Button'
import { Grid, Skeleton } from '@mui/material'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { useQuery } from 'react-query'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import dayjs from 'dayjs'

export const ArrayInputLogicSupplier = ({ record }) => {
  const translate = useTranslate()
  const { control } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: 'train_segment.setting',
  })
  const region = useQuery('ext-train-region', businessRuleServices.getTrainRegion)
  const supplier = useQuery('ext-train-supplier', businessRuleServices.getTrainSupplier)

  return (
    <>
      {React.Children.toArray(
        fields.map((field, index) => (
          <div
            key={field.id}
            style={{
              width: '100%',
              height: 'auto',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.region')} required lg={3} md={3}>
                {region.isLoading ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInputReactAdmin
                    source={`train_segment.setting.${index}.region`}
                    choices={region.data}
                    label={null}
                    fullWidth
                    optionText={'long_name'}
                    optionValue='short_name'
                    validate={[required()]}
                  />
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.supplier')} required lg={3} md={3}>
                {supplier.isLoading ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    source={`train_segment.setting.${index}.supplier`}
                    options={supplier.data}
                    label=''
                    optionsText={['long_name']}
                    optionValue='short_name'
                    size='small'
                    showSearch
                    multiple
                    defaultValue={record ? record?.train_segment?.setting?.[index]?.supplier : undefined}
                    validate={[required()]}
                  />
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.start_service_date')} lg={3} md={3}>
                <DatePickers source={`train_segment.setting.${index}.date_in_from`} viewsShow={false} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.end_service_date')} lg={3} md={3}>
                <FormDataConsumer>
                  {({ formData }) => {
                    const date_in_from = formData?.train_segment.setting?.[index]?.date_in_from
                    return (
                      <DatePickers
                        minDate={date_in_from ? dayjs(date_in_from) : false}
                        disabled={!date_in_from}
                        source={`train_segment.setting.${index}.date_in_to`}
                        required={date_in_from ? true : false}
                        viewsShow={false}
                      />
                    )
                  }}
                </FormDataConsumer>
              </EditInputsWrap>
            </Grid>
            <Grid container spacing={3} justifyContent='flex-end' className='addItemSeparator'>
              <Grid item xs={12} sm={12} className='grid'>
                <Button onClick={() => remove(index)} startIcon={<Delete />} color='error'>
                  {translate('ra.action.delete')}
                </Button>
              </Grid>
            </Grid>
          </div>
        ))
      )}
      <Button
        startIcon={<Add />}
        onClick={() =>
          append({
            marketing_carrier: null,
            condition: null,
            supplier: null,
            date_in_from: null,
            date_in_to: null,
          })
        }
      >
        {translate('ra.action.add_specific', {
          name: translate('ra.field.price_logic'),
        })}
      </Button>
    </>
  )
}
